<template>
  <div>
    <p>You searched for:</p>
    <ul>
      <li v-for="selectedVariable in selectedVariables">
        <strong>{{ findVariable(selectedVariable.id).label_name }}</strong> - between <strong>{{ selectedVariable.minValue }}</strong> and <strong>{{ selectedVariable.maxValue }}</strong>
      </li>
    </ul>

    <p><strong>{{ muscles.length }}</strong> matches found.</p>
    <p>Select the muscles and the profile you would like to view.</p>

    <div class="dcf-grid dcf-grid-halves@md">

      <div>
        <!-- profile selection -->
        <h3 class="dcf-txt-md">Profile:</h3>
        <dropdown v-model="selectedProfile" :options="profiles">
          <template #option="slotProps">
            <div>
              Type: <span v-text="(slotProps.option.type == 'D') ? 'Dairy' : 'Beef'"></span><br />
              Weight: {{ slotProps.option.weight }}<br />
              Muscling: {{ slotProps.option.muscling }}<br />
              Fat Thickness: {{ slotProps.option.fat_thick }}<br />
              Maturity: {{ slotProps.option.maturity }}<br />
            </div>
          </template>
          <template #value="slotProps">
            <div v-if="slotProps.value">
              Type: <span v-text="(slotProps.value.type == 'D') ? 'Dairy' : 'Beef'"></span><br />
              Weight: {{ slotProps.value.weight }}<br />
              Muscling: {{ slotProps.value.muscling }}<br />
              Fat Thickness: {{ slotProps.value.fat_thick }}<br />
              Maturity: {{ slotProps.value.maturity }}<br />
            </div>
            <div v-else>
              &hellip;
            </div>
          </template>
        </dropdown>
      </div>

      <div>
        <h3 class="dcf-txt-md">Muscles:</h3>

          <multiselect v-model="selectedMuscleIds" :options="muscles" optionLabel="name" optionValue="id" :showToggleAll="false" :filter="false" />

      </div>

    </div>

    <table class="dcf-table" v-if="selectedMuscleIds.length">
      <thead>
        <tr>
          <th>Variable</th>
          <th v-for="muscle in selectedMuscles" class="rotate"><div>{{ muscle.name }}</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="variable in vars" :class="(selectedVariableIds.indexOf(variable.id) > -1) ? 'unl-bg-light-green unl-green' : ''">
          <th>
            {{ variable.label_name }}
          </th>
          <td v-for="muscle in selectedMuscles" class="dcf-txt-right">
            {{ getProfileValue( muscle, variable.id, selectedProfile.id ) }}
          </td>
        </tr>
      </tbody>
    </table>

  </div>

  
</template>



<style>
th.rotate {
  height: 140px;
  white-space: nowrap;
}
th.rotate > div {
  transform: translate(25px, 0px) rotate(315deg);
  width: 30px;

}

</style>

<script>
import filter from 'lodash/filter';
import find from 'lodash/find';
import map from 'lodash/map';
import forEach from 'lodash/forEach';
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';

export default {
  data: function(){
    return {
      muscles: [],
      profiles: [],
      vars: [],
      selectedMuscleIds: [],
      selectedVariables: [],
      selectedProfile: null
    }
  },
  components: { dropdown: Dropdown, multiselect: MultiSelect },
  computed: {
    selectedMuscles: function(){
      var selectedMuscleIds = this.selectedMuscleIds;
      return filter( this.muscles, function(o){ return (selectedMuscleIds.indexOf(o.id) > -1 )});
    },
    selectedVariableIds: function(){
      return map(map(this.selectedVariables, 'id'), parseInt);
    }
  },
  methods: {
    findVariable: function(id){
      id = parseInt(id);
      return find( this.vars, function(o){ return o.id == id });
    },
    getProfileValue: function(muscle, label_id, selectedProfileId){
      return muscle.profile[ selectedProfileId ][ label_id ] ? this.numberPrecision( muscle.profile[ selectedProfileId ][ label_id ].mean, 3) : '---';
    },
    numberPrecision: function(val, precision){
      if(typeof val === 'string' || val instanceof String){
          return val;
        }

        val = parseFloat(val);

        if( val > 1000000){
          return val.toExponential();
        }
        if(isNaN(val)){
          return 'No Values';
        }
        return val.toLocaleString('en-US', {maximumFractionDigits: precision});
    }
  },
  created: function(){
    this.muscles = window.muscles;
    this.profiles = window.profiles;
    this.vars = window.variables;
    this.selectedVariables = window.selectedVariables;
    this.selectedProfile = this.profiles[0];
    let tmpMuscles = (window.muscles.length > 5) ? window.muscles.slice(0, 5) : window.muscles;
    this.selectedMuscleIds = tmpMuscles.map(function(m){ return m.id });;
  }
}
</script>
